module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-list', {
    attrs: {
      "listItems": _vm.trainList,
      "itemComponent": _vm.trainCard
    },
    on: {
      "list-item-clicked": _vm.onTrainClicked
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('evalContentmodal', {
    ref: "evalDetailDialog",
    attrs: {
      "showDialog": _vm.showEvalModal
    },
    on: {
      "close": _vm.close
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65b7b82a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/evaluation/digEvalContent.vue
// module id = 997
// module chunks = 2